import CommonHeader, { TabConfig } from '@/components/common/CommonHeader';
import { palette } from '@/modules/defines/styles';

const tabs: TabConfig[] = [
  { label: '공간 관리', path: '/space' },
  { label: '이벤트 관리', path: '/event' },
  { label: '통계', path: '/data' },
];

const ResomHeader = () => {
  return (
    <CommonHeader
      title="Resom ADMIN"
      backgroundColor={palette.main900}
      hoverColor={palette.main800}
      tabs={tabs}
      sessionCode="resom"
      baseRoute="/resom"
    />
  );
};

export default ResomHeader;
